import { render } from "./ggdy.vue?vue&type=template&id=f5b269e8&scoped=true"
import script from "./ggdy.vue?vue&type=script&lang=js"
export * from "./ggdy.vue?vue&type=script&lang=js"

import "./ggdy.vue?vue&type=style&index=0&id=f5b269e8&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b269e8"]])

export default __exports__